import type { Contact } from '@wix/ambassador-members-v1-member/types';

export const TEXT_FIELD_MAX_LENGTH = 120;

const customFieldsNamespace = 'customfields';
const systemNamespace = 'system';
const contactNamespace = 'contact';

export const EMAILS_FIELD_KEY =
  `${customFieldsNamespace}.${systemNamespace}.email` as keyof Contact;
export const PHONES_FIELD_KEY =
  `${customFieldsNamespace}.${systemNamespace}.phone` as keyof Contact;
export const ADDRESS_FIELD_KEY =
  `${customFieldsNamespace}.${systemNamespace}.address` as keyof Contact;
export const BIRTHDAY_FIELD_KEY =
  `${customFieldsNamespace}.${contactNamespace}.birthdate` as keyof Contact;
export const FIRST_NAME_FIELD_KEY =
  `${customFieldsNamespace}.${systemNamespace}.firstname` as keyof Contact;
export const LAST_NAME_FIELD_KEY =
  `${customFieldsNamespace}.${systemNamespace}.lastname` as keyof Contact;
export const POSITION_FIELD_KEY =
  `${customFieldsNamespace}.${contactNamespace}.position` as keyof Contact;
export const COMPANY_FIELD_KEY =
  `${customFieldsNamespace}.${contactNamespace}.company` as keyof Contact;

export const CITY_FIELD_KEY = `${customFieldsNamespace}.${systemNamespace}.city`;
export const COUNTRY_FIELD_KEY = `${customFieldsNamespace}.${systemNamespace}.country`;
export const SUBDIVISION_FIELD_KEY = `${customFieldsNamespace}.${systemNamespace}.subdivision`;
export const POSTAL_CODE_FIELD_KEY = `${customFieldsNamespace}.${systemNamespace}.postalcode`;
export const ADDRESS_LINE_FIELD_KEY = `${customFieldsNamespace}.${systemNamespace}.addressline`;
export const ADDRESS_LINE_2_FIELD_KEY = `${customFieldsNamespace}.${systemNamespace}.addressline2`;
